import { useLazyQuery, gql } from "@apollo/client"
import { useEffect } from "react"
import { useWaitUsrInteraction } from "shared-components/GlobalHooks/web/useWaitUsrInteraction"


const BANNER_POPUP_QUERY = gql`
  query BannerPopUp {
    featuredPopup {
      id
      title
      url
      image
      mobile_image
      video
      video_thumbnail
      html
    }
  }
`


const useBannerPopUp = () => {

	const { hasInteract } = useWaitUsrInteraction()
	const [getBannerPopUp, { data, error }] = useLazyQuery(
		BANNER_POPUP_QUERY,
		{ ssr: false }
	)

	useEffect(() => {
		if (hasInteract && typeof AbortController != 'undefined') getBannerPopUp() // lo del AbortController es para que no de error en browsers viejos
	}, [hasInteract])

	return {
		data: data?.featuredPopup,
		error: error
	}
}

export { useBannerPopUp }



